import React, { useEffect } from 'react';
import { initPixel } from './utils/pixel';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { FailedApproaches } from './components/FailedApproaches';
import { MethodSection } from './components/MethodSection';
import { WhatYouGet } from './components/WhatYouGet';
import { BonusesSection } from './components/BonusesSection';
import { InlineCTA } from './components/InlineCTA';
import { WhoIsFor } from './components/WhoIsFor';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { CreatorSection } from './components/CreatorSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initPixel();
  }, []);
  return <div className="w-full min-h-screen bg-cream font-sans" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <FailedApproaches data-id="element-3" />
      <MethodSection data-id="element-4" />
      <WhatYouGet data-id="element-5" />
      <BonusesSection data-id="element-6" />
      <InlineCTA data-id="element-7" />
      <WhoIsFor data-id="element-8" />
      <HowItWorks data-id="element-9" />
      <ProofSection data-id="element-10" />
      <CreatorSection data-id="element-11" />
      <TestimonialsSection data-id="element-12" />
      <FAQSection data-id="element-13" />
      <OfferSection data-id="element-14" />
      <Footer data-id="element-15" />
    </div>;
}